import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const CustomerReviews = () => {
  const reviews = [{
    id: 1,
    name: 'Sophie T.',
    location: 'Netherlands',
    rating: 5,
    text: "The Zakynthos hiking trip exceeded all my expectations. The guides were knowledgeable and the views were absolutely breathtaking. I'll definitely book another trip!",
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
    trip: 'Greece: Zakynthos Coastal Hike'
  }, {
    id: 2,
    name: 'Marco B.',
    location: 'Germany',
    rating: 5,
    text: 'The Cyprus Mountain Trail was a perfect blend of challenge and beauty. The accommodations were excellent and the local food experiences were a highlight!',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
    trip: 'Cyprus: Mountain Trail Adventure'
  }, {
    id: 3,
    name: 'Emma L.',
    location: 'United Kingdom',
    rating: 4,
    text: 'The Spanish Pyrenees trip was incredible. Our guide knew all the best spots and shared fascinating information about the local ecology. The only reason for 4 stars is that some days were quite challenging!',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    trip: 'Spain: Pyrenees Adventure'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % reviews.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + reviews.length) % reviews.length);
  };
  return <div className="relative max-w-3xl mx-auto" data-id="element-46">
      <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300" data-id="element-47">
        <div className="flex items-center mb-4" data-id="element-48">
          <img src={reviews[currentIndex].image} alt={reviews[currentIndex].name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-49" />
          <div data-id="element-50">
            <h3 className="font-bold text-gray-800" data-id="element-51">
              {reviews[currentIndex].name}
            </h3>
            <p className="text-sm text-gray-600" data-id="element-52">
              {reviews[currentIndex].location}
            </p>
          </div>
        </div>
        <div className="flex mb-3" data-id="element-53">
          {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} className={i < reviews[currentIndex].rating ? 'text-yellow-400 fill-current' : 'text-gray-300'} data-id="element-54" />)}
        </div>
        <p className="text-gray-700 mb-4" data-id="element-55">{reviews[currentIndex].text}</p>
        <p className="text-sm text-teal-600 font-medium" data-id="element-56">
          {reviews[currentIndex].trip}
        </p>
      </div>
      {/* Navigation buttons */}
      <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-12 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition" aria-label="Previous review" data-id="element-57">
        <ChevronLeftIcon size={24} className="text-gray-600" data-id="element-58" />
      </button>
      <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-12 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition" aria-label="Next review" data-id="element-59">
        <ChevronRightIcon size={24} className="text-gray-600" data-id="element-60" />
      </button>
      {/* Indicators */}
      <div className="flex justify-center mt-6 space-x-2" data-id="element-61">
        {reviews.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full ${currentIndex === index ? 'bg-teal-600' : 'bg-gray-300'}`} aria-label={`Go to review ${index + 1}`} data-id="element-62" />)}
      </div>
    </div>;
};